module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_29.49e445e1.jpg";